"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var Popover_1 = require("../Popover");
var controls_1 = require("../controls");
var Menu_1 = require("../Menu");
exports.getKey = function (key) { return key || Math.random().toString(); };
exports.getAdditionalContentNode = function (menuItemsRef) { var _a, _b; return (_b = (_a = menuItemsRef.current) === null || _a === void 0 ? void 0 : _a.map(function (nodeRef) {
    // eslint-disable-next-line react/no-find-dom-node
    return react_dom_1.findDOMNode(nodeRef.current);
})) !== null && _b !== void 0 ? _b : []; };
exports.removeEdgeSeparator = function (_a, idx, items) {
    var separator = _a.separator;
    return !(separator && (idx === 0 || items.length - 1 === idx));
};
exports.removeHidden = function (_a) {
    var hidden = _a.hidden;
    return !hidden;
};
var Submenu = function (_a) {
    var level = _a.level, menuItem = _a.menuItem, menuItemsRef = _a.menuItemsRef, getMenuItems = _a.getMenuItems, handleHide = _a.handleHide, otherOpenSubMenuOfThisLevel = _a.otherOpenSubMenuOfThisLevel;
    var renderControl = function (renderControlProps) {
        if (menuItem.renderControl) {
            return menuItem.renderControl(renderControlProps);
        }
        var ref = renderControlProps.button.ref, actions = renderControlProps.actions, isActive = renderControlProps.isActive;
        return (react_1.default.createElement(Menu_1.MenuItem, { "data-selector-id": "command-menu-submenu-" + (menuItem.id || menuItem.text), hasSubmenu: true, isActive: menuItem.isActive || isActive, disabled: menuItem.disabled, icon: menuItem.icon, onMouseDown: function (e) {
                var _a;
                e.preventDefault();
                e.stopPropagation();
                if (!menuItem.disabled) {
                    actions.show();
                    (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick) === null || _a === void 0 ? void 0 : _a.call(menuItem, e);
                }
            }, ref: ref }, menuItem.text));
    };
    var renderPopover = function (_a) {
        var popover = _a.popover, content = _a.content;
        if (level < menuItemsRef.current.length) {
            menuItemsRef.current = menuItemsRef.current.slice(0, level);
        }
        menuItemsRef.current.push(popover.ref);
        return react_1.default.createElement(Menu_1.Menu, __assign({}, popover), content);
    };
    var renderContent = function (renderContentSubmenuProps) {
        otherOpenSubMenuOfThisLevel.hide();
        otherOpenSubMenuOfThisLevel.hide = renderContentSubmenuProps.actions.hide;
        return (react_1.default.createElement(react_1.default.Fragment, null, getMenuItems({
            level: level,
            menuItems: menuItem.items,
            renderContentProps: renderContentSubmenuProps,
            menuItemsRef: menuItemsRef,
            handleHide: handleHide
        })));
    };
    return (react_1.default.createElement(controls_1.Dropdown, { popoverConfig: [{ xAxis: Popover_1.X_AXIS.outsideRight, yAxis: Popover_1.Y_AXIS.insideTop, offsetY: -1 }], getAdditionalContentNode: function () { return exports.getAdditionalContentNode(menuItemsRef); }, onOutsideClick: handleHide, renderControl: renderControl, renderPopover: renderPopover, renderContent: renderContent }));
};
exports.mapToElement = function (_a) {
    var level = _a.level, menuItem = _a.menuItem, menuItemsRef = _a.menuItemsRef, otherOpenSubMenuOfThisLevel = _a.otherOpenSubMenuOfThisLevel, renderContentProps = _a.renderContentProps, handleHide = _a.handleHide, getMenuItems = _a.getMenuItems;
    var _b;
    if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.separator) {
        return (react_1.default.createElement(Menu_1.MenuSeparator, { key: exports.getKey(menuItem.id || menuItem.text), "data-selector-id": "command-menu-item-" + (menuItem.id || menuItem.text) }));
    }
    if ((_b = menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) === null || _b === void 0 ? void 0 : _b.length) {
        return (react_1.default.createElement(Submenu, { key: exports.getKey(menuItem.id || menuItem.text), level: level, menuItem: menuItem, menuItemsRef: menuItemsRef, getMenuItems: getMenuItems, handleHide: handleHide, otherOpenSubMenuOfThisLevel: otherOpenSubMenuOfThisLevel }));
    }
    if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.renderContent) {
        return (react_1.default.createElement(react_1.default.Fragment, { key: exports.getKey(menuItem.id) }, menuItem.renderContent(renderContentProps)));
    }
    return (react_1.default.createElement(Menu_1.MenuItem, { key: exports.getKey(menuItem.id || menuItem.text), "data-selector-id": "command-menu-item-" + (menuItem.id || menuItem.text), isActive: menuItem.isActive, disabled: menuItem.disabled, icon: menuItem.icon, onClick: function (e) {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            handleHide();
            if (!menuItem.disabled) {
                (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick) === null || _a === void 0 ? void 0 : _a.call(menuItem, e);
            }
        } }, menuItem.text));
};
exports.getMenuItems = function (_a) {
    var _b = _a.level, level = _b === void 0 ? 0 : _b, menuItems = _a.menuItems, renderContentProps = _a.renderContentProps, menuItemsRef = _a.menuItemsRef, parentHandleHide = _a.handleHide;
    if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) {
        return null;
    }
    var otherOpenSubMenuOfThisLevel = {
        hide: function () { }
    };
    var handleHide = function () {
        renderContentProps.actions.hide();
        parentHandleHide === null || parentHandleHide === void 0 ? void 0 : parentHandleHide();
    };
    return menuItems
        .filter(exports.removeEdgeSeparator)
        .filter(exports.removeHidden)
        .map(function (menuItem) {
        return exports.mapToElement({
            level: level + 1,
            menuItem: menuItem,
            menuItemsRef: menuItemsRef,
            otherOpenSubMenuOfThisLevel: otherOpenSubMenuOfThisLevel,
            renderContentProps: renderContentProps,
            handleHide: handleHide,
            getMenuItems: exports.getMenuItems
        });
    });
};
exports.MenuItemDocStub = function () { return null; };
//# sourceMappingURL=helpers.js.map